
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 7,
  height: 10,
  viewBox: "0 0 7 10"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.264 4.6 5.91 1.197a.613.613 0 0 0 0-.909.727.727 0 0 0-.975 0L.802 4.145a.612.612 0 0 0 0 .91l4.134 3.857c.27.25.706.25.975 0a.614.614 0 0 0 0-.91L2.264 4.6z",
  fill: "#FFF",
  fillRule: "nonzero"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"7\" height=\"10\" viewBox=\"0 0 7 10\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g fill=\"#FFFFFF\" fill-rule=\"nonzero\">\r\n            <g>\r\n                <g>\r\n                    <g>\r\n                        <path d=\"M1.664 4.5L5.31 1.097c.269-.25.269-.658 0-.909-.27-.25-.706-.25-.975 0L.202 4.045c-.27.251-.27.659 0 .91l4.134 3.857c.27.25.706.25.975 0 .269-.251.269-.658 0-.91L1.664 4.5z\" transform=\"translate(-244 -492) translate(16 242) translate(228.6 247.4) translate(0 2.7)\"/>\r\n                    </g>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/arrow-white.6cc236d2513440b1512fc228179368b5.svg"),
        {
          React: SvgArrowWhite,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      